export default __webpack_public_path__ + "img/a85fb3f13694a2cfed7ded0d07f2ab87.svg";